<div class="tips-content">
  <mat-icon class="icon shrink-0">error</mat-icon>
  <div class="message"><ng-content></ng-content></div>
</div>
